import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Typography, Box, Button, TextField, LinearProgress } from '@mui/material';
import { Menu as MainMenu } from '../../components/Menu';

import { getTiers } from '../../api/tiers';
import { useData } from '../../hooks/DataProvider';

import { DataGrid } from '@mui/x-data-grid';

import translations from '../../scripts/translations';

const Tiers = () => {


    const { updateDataTier, language } = useData();
    const navigate = useNavigate();

    const btns = translations.button[language]
    const page = translations.pages.tiers[language]

    const [tiers, setTiers] = useState([]);

    const [tiersFilter, setTiersFilter] = useState({});
    const [loading, setLoading] = useState(false);


    const ALPHA_NUMERIC_DASH_REGEX = /^[a-zA-Z]+$/;


    const getLocalFilter = () => {
        const localFilter = localStorage.getItem('tiersFilter');
        return localFilter ? JSON.parse(localFilter) : {};
    };

    const setLocalFilter = (filter) => {
        localStorage.setItem('tiersFilter', JSON.stringify(filter));
    };


    const updateTiersFilter = (newFilter) => {
        let currentFilter = {}
        if (newFilter.value === '') {
            currentFilter = { ...tiersFilter };
            delete currentFilter[newFilter.field];
            setTiersFilter(currentFilter)
        }
        else {
            currentFilter = { ...tiersFilter, [newFilter.field]: newFilter.value }
        }
        // setLocalFilter(updatedFilter);
        setTiersFilter(currentFilter)
        setLocalFilter(currentFilter);

    }

    const clearTiersFilter = () => {
        setTiersFilter({});
        setLocalFilter({});
        fetchTiers({});
    };



    const fetchTiers = async (filter) => {
        try {
            setLoading(true);
            let startTime = new Date().getTime();
            const response = await getTiers(filter);
            setTiers(response);
            console.log('Tiers fetched successfully:', response);
            let endTime = new Date().getTime();
            console.log(`Fetch took ${endTime - startTime} ms`);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching tiers:', error);
        }
    };

    useEffect(() => {
        fetchTiers({});

        const filters = getLocalFilter()
        if (filters) {
            setTiersFilter(filters);
        }


    }, []);


    const handleTierUpdate = (tier) => {
        updateDataTier(tier);
        navigate(`/tiers/${tier._id}`);

    };


    const columnsTiers = [
        {
            field: 'code',
            headerName: page.searchByCode,
             width: 120
        },
        {
            field: 'name',
            headerName: page.searchByName,
            width: 250,
            editable: false,
        },
        {
            field: 'countryCode',
            headerName: page.searchByCountryCode,
            width: 100,
            editable: true,
        },
        {
            field: 'country',
            headerName: page.searchByCountry,
            width: 200,
            editable: true,
        },
        {
            field: 'zipCode',
            headerName: page.searchByZipCode,
            width: 100,
            editable: false,
        },
        {
            field: 'address',
            headerName: page.searchByAddress,
            width: 300,
            editable: false,
        },
        // {
        //     field: 'fullName',
        //     headerName: 'Full name',
        //     description: 'This column has a value getter and is not sortable.',
        //     sortable: false,
        //     width: 160,
        //     valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
        // },
    ];



    return (
        <>
            <MainMenu currentPage={'tiers'} />

            <Box sx={{ mb: 0, py: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='overline' component='h1' sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                    Tiers
                </Typography>

                <Link to={`/tiers/new`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Button variant='outlined' >{btns.add}</Button>
                </Link>
            </Box>


            {/* search barre  */}
            <Box sx={{ mb: 2, py: 2, display: 'flex', gap: 2, justifyContent: 'space-between', alignItems: 'center' }}>

                <TextField
                    label={page.searchByCode}
                    variant="outlined"
                    value={tiersFilter.code || ''}
                    size="small"
                    sx={{ width: '100%' }}
                    autoComplete='off'
                    onChange={(e) => updateTiersFilter({ field: 'code', value: e.target.value })}
                />
                <TextField
                    label={page.searchByName}
                    variant="outlined"
                    value={tiersFilter.name || ''}
                    size="small"
                    sx={{ width: '100%' }}
                    autoComplete='off'
                    onChange={(e) => updateTiersFilter({ field: 'name', value: e.target.value })}
                />

                <TextField
                    label={page.searchByCountryCode}
                    variant="outlined"
                    value={tiersFilter.countryCode || ''}
                    size="small"
                    sx={{ width: '100%' }}
                    autoComplete='off'
                    onChange={(event) => {
                        const value = event.target.value;
                        if (value !== "" && !ALPHA_NUMERIC_DASH_REGEX.test(value)) {
                            return;
                        }
                        updateTiersFilter({ field: 'countryCode', value: value.toLocaleUpperCase() })
                    }}

                />
                <TextField
                    label={page.searchByZipCode}
                    variant="outlined"
                    value={tiersFilter.zipCode || ''}
                    size="small"
                    sx={{ width: '100%' }}
                    autoComplete='off'
                    onChange={(e) => updateTiersFilter({ field: 'zipCode', value: e.target.value })}
                />
                <TextField
                    label={page.searchByCity}
                    variant="outlined"
                    value={tiersFilter.city || ''}
                    size="small"
                    sx={{ width: '100%' }}
                    autoComplete='off'
                    onChange={(e) => updateTiersFilter({ field: 'city', value: e.target.value })}
                />


                <Box sx={{ display: 'flex', gap: 1 }}>

                    <Button variant='outlined' onClick={clearTiersFilter} >{btns.reset}</Button>
                    <Button variant='outlined' onClick={() => {
                        console.log(tiersFilter)
                        fetchTiers(tiersFilter)
                    }} >{btns.search}</Button>
                </Box>




            </Box>



            {loading && <LinearProgress sx={{ mb: 2 }} />}

            {!loading && <Box sx={{ height: 520, width: '100%' }}>
                <Box sx={{  width: '100%' }}>
                    <DataGrid
                        rows={tiers}
                        getRowId={(row) => row._id}
                        columns={columnsTiers}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                },
                            },
                        }}
                        showToolbar={true}
                        slotProps={{
                            toolbar: {
                                printOptions: { disableToolbarButton: true },
                            },
                        }}
               
                        pageSizeOptions={[25]}
                        disableRowSelectionOnClick
                        onRowClick={(params) => handleTierUpdate(params.row)}
                        sx={{
                            '& .MuiDataGrid-row:hover': {
                                cursor: 'pointer',
                            },
                        }}
                    />
                </Box>
            </Box>
            }


        </>
    );
}

export default Tiers;